<forge-card class="no-padding" telemetry="Submission-SearchCard" outlined="outlined">
    <div fxLayout="row" fxLayoutAlign="space-around center" class="tt-card-header-container info-card-header">
        <div fxFlex="auto">
            <span fxLayout="row" fxLayoutAlign="space-between center" fxFlex="auto" style="min-width:0">
                <span fxLayout="row" fxLayoutAlign="start center">
                    @if (hasEmblemText()) {
                    <span class="avatarWrapper" tabindex="-1" (click)="$event.stopPropagation()"
                        telemetry="Submission-StopProp">
                        <forge-avatar [text]="emblemText" telemetry="emblemText"></forge-avatar>
                    </span>
                    }

                    <div fxFlex="auto" fxLayout="column" fxLayoutAlign="center start" class="truncate">
                        <div fxLayout="row" class="forge-typography--heading4">
                            <!--                            <div fxLayout="row" [ngClass]="{'content-display': $last}">-->
                            <div fxLayout="row">
                                <div class="truncate" telemetry="title">{{title}}</div>
                            </div>
                            <div [hidden]="!showHeaderBadge" class="tt-margin--left" fxLayout="row"
                                fxLayoutAlign="start center">
                                @for (badge of visibleHeaderBadges; track badge) {
                                <forge-badge [attr.theme]="badge.Theme">
                                    {{badge.Text}}
                                </forge-badge>
                                }
                            </div>
                        </div>
                        @if (subHeaders.length > 0) {
                        <div fxLayout="row" style="width: 100%;">
                            @for (value of subHeaders; track value) {
                            <div fxLayout="row" [ngClass]="{'content-display': $last}">
                                <div class="truncate" [attr.telemetry]="value">{{value}}</div>
                                @if (!$last) {
                                <div>&nbsp; &bull; &nbsp;</div>
                                }
                            </div>
                            }
                        </div>
                        }
                    </div>
                </span>

                <span fxFlex="auto" fxLayout="row" fxLayoutAlign="end end">
                    @if (canEdit) {
                    <forge-icon-button (click)="onClicked()" telemetry="Submission-Edit">
                        <forge-tooltip placement="bottom">Edit</forge-tooltip>
                        <forge-icon name="edit"></forge-icon>
                    </forge-icon-button>
                    }
                    <div fxFlex="5"></div>
                    <metadata-action-menu fxLayout="row" fxLayoutAlign="end center"
                        [metadataActions]="cardMetadata.ChipMetadata" [model]="model" [formData]="datacontroller"
                        (actionCallback)="afterAction($event)">
                    </metadata-action-menu>
                </span>
            </span>
        </div>
    </div>
    <div class="tt-card-body">
        <metadata-panel view-only="true" [model]="displayModel" [metadata]="metadata" [dense]="dense">
        </metadata-panel>
    </div>
</forge-card>